import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'types/state'
import type { Shape, ShapesAllMap, ShapesByEntityMap } from 'types/shapes'
import selectFocus from './focus'

export const selectShapes = (state: RootState): ShapesAllMap => {
  return state.graph?.shapes?.all || {}
}

export const selectShapesByEntity = (state: RootState): ShapesByEntityMap => {
  return state.graph?.shapes?.byEntity || {}
}

export const selectFocusedShapeId = createSelector(selectFocus, selectShapesByEntity, (focus, byEntity): string | null => {
  return byEntity[focus.id]?.[0] ?? null
})

export const selectFocusedShape = createSelector(selectFocusedShapeId, selectShapes, (shapeId, shapes): Shape | null => {
  return shapeId ? shapes[shapeId] ?? null : null
})
